import React from 'react'
import {idStyle, nameStyle} from './styles'

const renderName = ({id, name}, path, showLink, size) => (
    <div className="name" data-testid="name" style={nameStyle(size)}>
        {showLink ? (
            <a
                target="_blank"
                rel="noopener noreferrer"
                href={`/profile/${path}/${id}`}
                data-testid="link"
            >
                {name}
            </a>
        ) : (
            name
        )}
    </div>
)

function copyText(id) {
    return async () => {
        await navigator.clipboard.writeText(id)
    }
}

const renderId = (id, hideId, size, showParens = true, maxLength = -1) => {
    const shortId =
        maxLength > 0
            ? id.toUpperCase().slice(0, maxLength) + (id.length > maxLength ? '...' : '')
            : id
    const idText = showParens ? `(${shortId.toUpperCase()})` : shortId.toUpperCase()
    if (hideId) return null
    const isTooLong = maxLength > 0 && id.length > maxLength
    return (
        <div className="id" data-testid="id" style={idStyle(size)}>
            {isTooLong && (
                <div className="tooltip" onClick={copyText(id)}>
                    {idText}
                    <span className="tooltiptext">
                        {id}
                        <div className="copy-instructions">Click to copy</div>
                    </span>
                </div>
            )}
            {!isTooLong && idText}
        </div>
    )
}

const renderMemberCount = (memberCount, showMemberCount, size) =>
    showMemberCount && (
        <div className="memberCount" style={idStyle(size)}>
            ({memberCount} members)
        </div>
    )

// eslint-disable-next-line consistent-return
const idCheck = (type) => (props) => {
    if (props[type] === undefined && props.id === undefined) {
        return new Error(`either 'id' or '${type}' property is required`)
    }
    if (props.id !== undefined && typeof props.id !== 'string') {
        return new Error(`invalid property type for 'id', expected string type`)
    }
}
export {renderId, renderName, renderMemberCount, idCheck}
